import { RejoinModal } from '../../../session/rejoin/RejoinModal';
import { useVisitorRejoinModalViewModel } from './useVisitorRejoinModalViewModel';

export function VisitorRejoinModalWrapper() {
  const props = useVisitorRejoinModalViewModel();

  return <RejoinModal {...props} />;
}
